<ng-container *commonMojoFeatureFlag="'MOJAT-5483'">
  <ng-container *ngIf="(extraInfo$ | async)?.length > 0">
    <div
      [matMenuTriggerFor]="candidateExtraInfoTooltip"
      #menuTrigger="matMenuTrigger"
      (mouseenter)="mouseEnter(menuTrigger)"
      (mouseleave)="mouseLeave(menuTrigger)"
    >
      <mat-icon
        class="icon"
        [inline]="true"
      >assignment</mat-icon> Q & A
    </div>
    <mat-menu
      #candidateExtraInfoTooltip="matMenu"
      class="custom-menu-class"
      [hasBackdrop]="false"
      yPosition="below"
    >
      <div
        (click)="$event?.stopPropagation()"
        class="candidate-extra-info-container"
        (mouseenter)="mouseEnter(menuTrigger)"
        (mouseleave)="mouseLeave(menuTrigger)"
      >
        <div
          class="qa-container"
          *ngFor="let extraInfo of (extraInfo$ | async)"
        >
          <div class="qa-question">{{extraInfo?.question}}</div>
          <div class="qa-answer">
            {{extraInfo?.answer === '' || extraInfo?.answer === null ? '-' : extraInfo?.answer}}
          </div>
        </div>
      </div>
    </mat-menu>
  </ng-container>
</ng-container>
